import { Typography } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import { withStyles } from '@material-ui/core/styles';
import WarningIcon from '@material-ui/icons/Warning';
import PropTypes from 'prop-types';
import React from 'react';
import CancelButton from '../CancelButton';
import PrimaryButton from '../PrimaryButton';
import { globalStyles as styles } from '../style/gstheme';

class CheckDeleteAccountDialog extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      open: true
    };
  }

  notSure = () => {
    this.setState({ open: false });
    this.props.onNotSure();
  }

  sure = () => {
    this.setState({ open: false });
    this.props.onSure();
  }

  render() {

    const { classes } = this.props;

    return (
      <Dialog
        data-test="delete-account-dialog"
        maxWidth="md"
        fullWidth
        classes={{
          paperWidthMd: classes.smallDialog
        }}
        open={this.state.open}
        aria-label="Delete Account" >
        <DialogContent>
          <div style={{ textAlign: 'center' }}>
            <WarningIcon style={{ color: '#DD2C00', height: 32, width: 32 }} />
            <Typography paragraph className={classes.mainHeading} style={{ color: '#DD2C00' }}>Delete Account</Typography>
            <div style={{ textAlign: 'left' }}>
              <Typography paragraph variant="body2">This action will permanently delete your account.</Typography>
              <Typography paragraph variant="body2">Access to your subscriptions will be removed for all users within the next few minutes. You will still be billed for the full current billing period.</Typography>
              <Typography paragraph variant="body2">Your personal data will be deleted within a short period of time.</Typography>
              <Typography paragraph variant="body2">All of the data created by you using Graphologi will also be deleted. This will be unrecoverable - the data cannot be retrieved afterwards.</Typography>
              <Typography paragraph variant="body2" style={{ fontWeight: 'bold' }}>You cannot undo this action.</Typography>
            </div>
          </div>
        </DialogContent>
        <DialogActions className={classes.dialogActions}>
          <CancelButton onClick={this.notSure}>Close</CancelButton>
          <PrimaryButton important={true} onClick={this.sure}>Proceed with Deletion</PrimaryButton>
        </DialogActions>
      </Dialog>
    );
  }
}

CheckDeleteAccountDialog.propTypes = {
  classes: PropTypes.object,
  onSure: PropTypes.func.isRequired,
  onNotSure: PropTypes.func.isRequired
};

export default withStyles(styles)(CheckDeleteAccountDialog);